import { isNil } from 'lodash-es';

/**
 * Every key of `T` must be present, but each value keeps `T`'s optionality.
 * Unlike `Required<T>` (which strips `undefined` and would reject optional
 * passthrough), this only enforces KEY coverage — so adding a new optional
 * field to a write CV forces every `satisfies Complete<...>` projection to
 * handle it instead of silently dropping it.
 */
export type Complete<T> = { [K in keyof Required<T>]: T[K] };

export function checkRequired(value: unknown, strict = false): boolean {
  return strict ? !isNil(value) : value !== null;
}

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export function checkEmail(email: string): boolean {
  return EMAIL_REGEXP.test(email);
}
